import { Component, input, output, inject, signal, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormMode } from 'app/core/constants/form-mode';
import { CatalogService } from '@services/data/catalog.service';
import { AppSettings } from '@services/settings/app-settings.service';
import { ListCardComponent } from 'app/core/components/list-card/list-card.component';

@Component({
    selector: 'app-user-entities-list',
    standalone: true,
    imports: [CommonModule, FormsModule, ListCardComponent],
    templateUrl: './user-entities-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./user-entities-list.component.css']
})
export class UserEntitiesListComponent {
    entities = input.required<any[]>();
    /** @deprecated Ya no condiciona agregar/eliminar; se usa canManage. */
    mode = input<FormMode>(FormMode.VIEW);
    allowedEntities = input<any[]>([]);
    title = input<string>('Entidades');
    emptyMessage = input<string>('No hay entidades asociadas a este rol.');
    /** Siempre true en gestión: agregar/eliminar independientes del Editar del formulario. */
    canManage = input<boolean>(true);
    /** Rol Usuario: no hay entidades; el padre muestra el mensaje y deja el select. */
    hideEntities = input(false);
    formMode = FormMode;

    onRemove = output<number>();
    onAdd = output<void>();

    searchTerm = signal<string>('');
    catalogService = inject(CatalogService);
    public appSettings = inject(AppSettings);

    canRemoveEntity(entityCode: number): boolean {
        const allowed = this.allowedEntities();
        if (!allowed?.length) return true;
        return allowed.some(e => Number(e.code) === Number(entityCode));
    }

    filteredEntities = computed(() => {
        const term = this.searchTerm().toLowerCase();
        if (!term) return this.entities();
        return this.entities().filter(e =>
            String(e.name || '').toLowerCase().includes(term) ||
            String(e.code).includes(term)
        );
    });

    removeEntity(code: number) {
        this.onRemove.emit(code);
    }

    addEntity() {
        this.onAdd.emit();
    }
}
